/** @format */

import React, { useState } from 'react'
import { _$, Card, Tabs, Tab } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import PythonLogo from 'src/assets/img/Python.png'
import PythonAccess from './components/PythonAccess'
import useNavRegion from 'src/hooks/useNavRegion'

type TabType = 'python'

const AccessCenter: React.FC<{ className?: string }> = ({ className }) => {
  const [tab, setTab] = useState<TabType>('python')
  // 控制台region
  const region = useNavRegion()
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('AI可观测') }, { title: _$('接入中心') }]} />
      <Card title={_$('接入中心')}>
        <Tabs value={tab} onChangeValue={setTab}>
          <Tab value="python">
            <img width={24} height={24} src={PythonLogo} alt="Python" />
            <span style={{ marginLeft: '8px' }}>{_$('Python')}</span>
          </Tab>
        </Tabs>
        {tab === 'python' ? <PythonAccess region={region} /> : null}
      </Card>
    </div>
  )
}

export default styled(AccessCenter)`
  padding: 0 16px;
`
